var chartSortButtonIcon = {
    base: {
        display: "inline-block",
        ">[data-icon-direction='down']": {
            transform: "scaleY(-1)",
        },
    },
};

export { chartSortButtonIcon };
//# sourceMappingURL=chart-sort-button.js.map
